import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ElaborationDocumentFilter } from '../../models/elaboration-doc-filter';
import { DocumentManagementStoreService } from '../../services/document-management-store.service';
import { DocumentManagementService } from '../../services/document-management.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-document-filter',
  templateUrl: './document-filter.component.html',
  styleUrls: ['./document-filter.component.css']
})
export class DocumentFilterComponent implements OnInit {

  @Input() elaborationId: string;

  topics$: Observable<ElaborationDocumentFilter[]>;
  entities$: Observable<ElaborationDocumentFilter[]>;
  sections$: Observable<ElaborationDocumentFilter[]>;
  isTabletSizeScreen = false;
  constructor(
    private documentManagementService: DocumentManagementService,
    private dmStore: DocumentManagementStoreService,
    private responsive: ResponsiveService
  ) { }

  ngOnInit() {
    this.documentManagementService.getElaborationTopics(this.elaborationId).subscribe(res => this.dmStore.updateTopics(res));
    this.documentManagementService.getElaborationEntities(this.elaborationId).subscribe(res => this.dmStore.updateEntities(res));
    this.documentManagementService.getElaborationSections(this.elaborationId).subscribe(res => this.dmStore.updateSections(res));
    this.entities$ = this.dmStore.entities$;
    this.topics$ = this.dmStore.topics$;
    this.sections$ = this.dmStore.sections$;
    this.responsive.checkScreenSizeDynamic([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium
    ]).subscribe(
      state => this.isTabletSizeScreen =  state.matches
    )
  }

  switch(event: any, filter: ElaborationDocumentFilter){
    if(event.currentTarget.checked) {
      this.dmStore.aggiungiFiltro(filter);
    } else {
      this.dmStore.rimuoviFiltro(filter);
    }
  }

  formatLabel(label: string): string {
    return label
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  }


}
